export default __webpack_public_path__ + "static/media/logoheader.72a995eb.webp";